module.exports = __webpack_public_path__ + "static/cta-background-d32ccaf671ba7fbe1d2eae072196d2b4.png";